import { render } from "./VenueTable.vue?vue&type=template&id=3b35fa2e&scoped=true"
import script from "./VenueTable.vue?vue&type=script&lang=js"
export * from "./VenueTable.vue?vue&type=script&lang=js"

import "./VenueTable.vue?vue&type=style&index=0&id=3b35fa2e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b35fa2e"]])

export default __exports__